import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import { Communication } from '@models/partner/communication/communications.interface';
import { CommunicationWebservice } from '@webservices/communication/communication.webservice';

export const CommunicationsResolver: ResolveFn<Communication[]> = () =>
  inject(CommunicationWebservice).getDashboardCommunications();
